import { ServiceData } from '@/types';

import articles from './PILATES_ARTICLES_EN.json';
import exercises from './PILATES_EXERCISES_EN.json';
import recipes from './PILATES_RECIPES_EN.json';

export const PILATES_DATA_EN: ServiceData = {
  articles,
  exercises,
  recipes,
};
